import { FormEvent, useEffect, useState } from 'react';
import OnelivePageLayout from './OnelivePageLayout';
import OneliveSubPageLayout from './OneliveSubPageLayout';
import { FaqItem, FaqPageData, fetchFaqData } from './api';

export default function FaqPage() {
  const [data, setData] = useState<FaqPageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [openId, setOpenId] = useState<number | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const faq = await fetchFaqData(search ? { search } : undefined);
        if (mounted) {
          setData(faq);
          setOpenId(null);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [search]);

  const items = data?.items ?? [];

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    setSearch(searchInput.trim());
  };

  return (
    <OnelivePageLayout pageClassName="onelive-faq-page">
      <OneliveSubPageLayout title="자주하시는 질문">
        <fieldset className="onelive-faq-search-wrap">
          <legend>FAQ 검색</legend>
          <form onSubmit={handleSearch}>
            <input
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="FAQ 검색"
              maxLength={50}
            />
            <button type="submit">
              <span className="onelive-faq-search-icon" aria-hidden="true">⌕</span>
              검색
            </button>
          </form>
        </fieldset>

        <div className="onelive-faq-list-wrap">
          {loading ? (
            <p className="onelive-sub-loading">로딩 중...</p>
          ) : items.length === 0 ? (
            <p className="onelive-sub-empty">등록된 FAQ가 없습니다.</p>
          ) : (
            <ol className="onelive-faq-list">
              {items.map((item: FaqItem) => {
                const isOpen = openId === item.id;
                return (
                  <li key={item.id} className={isOpen ? 'is-open' : ''}>
                    <h3
                      role="button"
                      tabIndex={0}
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setOpenId(isOpen ? null : item.id);
                        }
                      }}
                    >
                      <span className="onelive-faq-q-badge" aria-hidden="true">Q</span>
                      <span className="onelive-faq-question-text">{item.question}</span>
                    </h3>
                    {isOpen ? (
                      <div className="onelive-faq-answer-inner">
                        <span className="onelive-faq-a-badge">A</span>
                        <div
                          className="onelive-faq-answer-content"
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        />
                        <div className="onelive-faq-close-row">
                          <button type="button" onClick={() => setOpenId(null)}>닫기</button>
                        </div>
                      </div>
                    ) : null}
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </OneliveSubPageLayout>
    </OnelivePageLayout>
  );
}
